$(document).ready(function () {

  var $triggerSections = $(".single-case_studies .page-wrapper").children();

  $triggerSections.each(function () {
    var $section = $(this);
    var animations = $section.data("animations");
    var windowHeight = $(window).height();
    var navHeight = $(".navigation").height();

    if (animations) {
      new Waypoint({
        element: $section[0],
        handler: function(direction) {
          if (animations) {
            var animationCalls = animations.split(",");
            animationCalls.forEach(function (animation) {
              triggerAnimation($section, animation);
            });
          }
        },
        offset: '70%'
      });
    }
  });
});

function triggerAnimation($section, animation) {
  if (window[animation] && typeof window[animation] == "function") window[animation]($section);
}